import { ActivatedRoute } from '@angular/router';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { TextFilter, ComboStoreComponent } from '../../common-page-components/stores/filters-store/filters-store';
import { HttpClient } from '@angular/common/http';
import { FiltersAbstractService } from '../../common-page-components/classes/filters-abstract-service';
import { map, mergeMap, tap, filter } from 'rxjs/operators';
import { ViewDataService, WaHelperService, } from 'world-archery-lib';
import * as i0 from "@angular/core";
import * as i1 from "../../library/wa-services/view-data-service";
import * as i2 from "../../library/wa-services/wa-helper-service";
import * as i3 from "@angular/common/http";
import * as i4 from "@angular/router";
export class FiltersAmateursRankingService extends FiltersAbstractService {
    constructor(views, helper, http, route) {
        super();
        this.views = views;
        this.helper = helper;
        this.http = http;
        this.route = route;
        this.textSearch = new TextFilter('indoorteamseriestext', undefined, undefined, 'search');
        this.categoriesCombo = new ComboStoreComponent('Categories:', 'Name', 'indoorteamseriescategory', undefined, undefined, this.http, 'WORLDCUPRANKINGSCATEGORIES', [], [], true, 'category');
        this.yearCombo = new ComboStoreComponent('Year:', 'Year', 'indoorteamseriesyear', undefined, undefined, this.http, 'SERIES', [], [], true, 'year');
        this.filtersType = [
            this.textSearch.filterInfo,
            this.categoriesCombo.filterInfo,
            this.yearCombo.filterInfo
        ];
        this.textSubject = new BehaviorSubject('');
        this.generateDefaultValues();
        // this.sortLocator.asc = true;
    }
    generateDefaultValues() {
        this.yearCombo.filterInfo.options.initial_state = true;
        this.yearCombo.requestData({ 'DisciplineId': 2, 'RBP': 'ALL' }, false).pipe(map(a => a.items), mergeMap(next => {
            let comboSeason = [];
            let index = next.findIndex(value => value.discipline === 2);
            let selected = comboSeason[index];
            comboSeason = next.filter(value => value.Year >= 2019 && value.Discipline === 2);
            if (this.route.snapshot.queryParams['year']) {
                index = comboSeason.findIndex(value => value.Year.toString() === this.route.snapshot.queryParams['year']);
                if (index > -1) {
                    selected = comboSeason[index];
                }
            }
            else {
                selected = WaHelperService.getComboSeasonItemByCurrentYear(comboSeason);
            }
            this.filtersType[2].options.options_subject.next(comboSeason);
            this.filtersType[2].options.options_selected_subject.next(selected);
            return of(next);
        })).subscribe();
        this.filtersType[2].options.options_selected_subject.asObservable().pipe(filter((a) => a && a.Year != undefined), mergeMap((a) => {
            return this.categoriesCombo.requestData({ 'DisciplineId': 2, 'RBP': 'ALL', 'Year': a.Year }, false)
                .pipe(map(a => a.items), map((data) => data.filter(value => value.Team === false && value.Pro === false)), tap(next => {
                next.forEach(value => {
                    value.name = value.Name
                        ? value.Name
                        : this.helper.getCategoryInfoByCode(value.Cat).name;
                });
                this.filtersType[1].options.options_subject.next(next);
                this.filtersType[1].options.options_selected_subject.next(next[0]);
            }));
        })).subscribe();
    }
    getDataStreamWithFilters() {
        return;
    }
}
FiltersAmateursRankingService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function FiltersAmateursRankingService_Factory() { return new FiltersAmateursRankingService(i0.ɵɵinject(i1.ViewDataService), i0.ɵɵinject(i2.WaHelperService), i0.ɵɵinject(i3.HttpClient), i0.ɵɵinject(i4.ActivatedRoute)); }, token: FiltersAmateursRankingService, providedIn: "root" });
